import { Translation } from '../Interfaces/Translation.interface';

export const prepareTranslations = (values?: Translation[]): Record<string, string> | undefined => {
	if(!values || values.length === 0) {
		return undefined;
	}
	return values.reduce<Record<string, string>>((acc, item) => {
		acc[item.key] = item.value;
		return acc;
	}, {})
}